import Ship from "@/model/Ship"
import FuelType from "@/model/FuelType"
import ShipType from "@/model/ShipType"
import { shipTypeCodes } from "../../utils/constants"
import ParametricTableService from "../ParametricTableService"
import utils from "@/utils/configuration/config.js"
import ShipTypeService from "../ShipTypeService"
import FuelTypeService from "../FuelTypeService"
import NeobuqCarbonData from "@/model/Neobuq/NeobuqCarbonData"
import { unsignedDecimalNumber } from "docx"

class auxData{
    public year : string = ""
    public value : number = 0
}

class NeobuqCarbonService{

    private static instance: NeobuqCarbonService;

    private constructor() {}

    public static getInstance(): NeobuqCarbonService {
        if (!NeobuqCarbonService.instance) {
            NeobuqCarbonService.instance = new NeobuqCarbonService();
        }

        return NeobuqCarbonService.instance;
    }

    public calc_anual_prewritten_CII(ship: Ship){

        const parametricTables = ParametricTableService.getInstance().getParametricTable(
            utils.config.firebaseConfig.parametricVersion
        )
        
        const ciiref = this.calc_reference_CII(ship)
        //console.log("CIIref")
        //console.log(ciiref)
        const list_prewritten_CIIs : Array<number> = new Array<number>()
        const list_Z = parametricTables["carbonReductionFactor"]
        let res = 0

        //revisar años, empieza en 2023 no en 2021
        for(let i = 2; i<list_Z.length; i++){

            res = (1 - list_Z[i]/100) * ciiref
            //console.log("Z: " +list_Z[i] +" - Año " + i + ": " + res)
            list_prewritten_CIIs.push(res)
        }

        return list_prewritten_CIIs
    }

    public calc_old_attained_CII(ship : Ship){

        let numerador = 0

        for(let i=0; i < ship.fuelConsumption.length; i++){

            if(ship.fuelConsumption[i].fuel.for_cii){
                //multiplicamos el consumo por 1000000 porque tenemos que pasar de toneladas a gramos
                numerador = numerador + ((ship.fuelConsumption[i].consumption*1000000) * ship.fuelConsumption[i].fuel.cii_cf)
            }
        }

        //nos aseguramos que el numerados es distinto de 0 (significa que hay combustibles 'viejos')
        if(numerador != 0){
            const capacity = this.calc_capacity(ship.dwt, ship.gt, ship.shipType)
            const denominador = capacity * ship.totalDistance
    
            const old_attained_CII = numerador/denominador
    
            return old_attained_CII
        }
    }

    public calc_attained_CII(ship: Ship, data: NeobuqCarbonData, anualPrewrittenCII : Array<auxData>){

        //data serán otros datos que nos vamos a guardas en la variable ship
        //esto se va a calcular para cada año (2023-2040), 18 años
        const numYearsToApply = 18
        let numAux = 23
        let yearStr = "20" + numAux 
        //ship.baseCII = []
        const arrayCII = [{}]

        for(let i=0; i<numYearsToApply; i++){

            let res_CII = 0
            let numerador = 0
            let letter = ""

            //sumatorio de los tipos de combustibles diferentes
            for(let j=0; j<data.numFuels; j++){

                const fc = data.arrayFuelVariables[j].fuel.consumption
                //console.log("fc para " +  data.arrayFuelVariables[j].fuel.fuel.name + ": " + fc)
                const cf_cii = data.arrayFuelVariables[j].fuel.fuel.cii_cf
                const y = i //la y indica el año
                let tf = 0

                //si es o Shuttle o STS; NO se utilizan ni FCelectrical, ni FCboiler ni FCothers
                if(ship.shipType.code == "TNK" && (data.shipTankerType.name == "Lanzadera (Shuttle)" || data.shipTankerType.name == "STS (Ship to Ship)") ){

                   
                    //console.log("data.shipTankerType.name ")
                    //console.log(data.shipTankerType.name )
                    let fcs = 0
                    let aTanker = 0

                    if(data.shipTankerType.name == "Lanzadera (Shuttle)"){

                        fcs = fc
                        aTanker = 5.6805 * Math.pow(ship.dwt,(-0.208))

                    }else if(data.shipTankerType.name == "STS (Ship to Ship)"){

                        fcs = data.arrayFuelVariables[j].FCs
                        aTanker = 6.1742 * Math.pow(ship.dwt,(-0.246))
                    }

                    tf = (1 - aTanker) * fcs
                    
                    //hacemos el numerador correspondiente a estas opciones
                    const numeradorAux = cf_cii * (fc - (data.arrayFuelVariables[j].FCvoyage + tf + (0.75 - 0.03*y)))
                    numerador = numerador + numeradorAux

                }
                //aquí SÍ se utilizan FCelectrical, FCboiler y FCothers
                else{

                    let fc_electrical = 0
                    const fc_boiler = data.arrayFuelVariables[j].FCboiler
                    const fc_others = data.arrayFuelVariables[j].FCothers
                    const sfoc = data.arrayFuelVariables[j].SFOC

                   //calculamos FCelectrical
                   if(data.arrayFuelVariables[j].typeFCelec.name == "Contenedores refrigerados (reefer)"){

                    if(data.arrayFuelVariables[j].canMonitorElecConsumption == "Yes"){
                        fc_electrical = data.arrayFuelVariables[j].reefer * sfoc
                    }else{
                        const cx = 2.75
                        const reefer_days_sea = data.arrayFuelVariables[j].daysSea * data.arrayFuelVariables[j].numContainers
                        const reefer_days_port = ((data.arrayFuelVariables[j].nocArrival + data.arrayFuelVariables[j].nocDeparture)/2) * data.arrayFuelVariables[j].daysPort

                        fc_electrical = cx * 24 * sfoc * (reefer_days_sea + reefer_days_port)
                    }

                   }else if(data.arrayFuelVariables[j].typeFCelec.name == "Sistemas de refrigeración en buques gaseros y GNL (cooling)"){
                    fc_electrical = data.arrayFuelVariables[j].cooling * sfoc
                   }else if(data.arrayFuelVariables[j].typeFCelec.name == "Bombas de descarga eléctricas (discharge)"){
                    fc_electrical = data.arrayFuelVariables[j].discharge * sfoc
                   }

                   //console.log("fc_electrical para " +  data.arrayFuelVariables[j].fuel.fuel.name + ": " + (fc_electrical/1000000))
                   

                   const numeradorAux = cf_cii * (fc - (data.arrayFuelVariables[j].FCvoyage + tf + (0.75 - 0.03*y) * ((fc_electrical/1000000)+ fc_boiler + fc_others)))
                   //console.log("Término numerador de " +  data.arrayFuelVariables[j].fuel.fuel.name + ": " + numeradorAux)
                   numerador = numerador + numeradorAux
                }
            }

            //obtenemos los coeficientes f (fi, fm, fc y fivse)
            const fi = this.calc_fi(ship, data)
            //console.log("fi: " + fi)
            const fm = this.calc_fm(ship, data)
            //console.log("fm: " + fm)
            const fc_const = this.calc_fc(ship, data)
            //console.log("fc_const: " + fc_const)
            const fi_vse = this.calc_fi_vse(ship, data)
            //console.log("fi_vse: " + fi_vse)
            //obtenemos la capacidad, dt y dx
            const capacity = this.calc_capacity(ship.dwt, ship.gt, ship.shipType)
            const dt = ship.totalDistance
            const dx = data.travelDistance

            const denominador = fi * fm * fc_const * fi_vse * capacity * (dt - dx)
            //console.log("El denominador es: " + denominador)

            res_CII = Number(((numerador / denominador)*1000000).toFixed(2))
            letter = this.calc_letter_values(ship, anualPrewrittenCII[i], res_CII)

            const auxCII = {year : yearStr, value : res_CII, letter : letter, color: ""}
            //guardamos el resultado
            //ship.baseCII.push(auxCII)
            arrayCII.push(auxCII)

            numAux = numAux + 1
            yearStr = "20" + numAux
        }

        ship.dataForCII = data
        arrayCII.splice(0,1)
        return arrayCII
    }

    public calc_letter_values(ship: Ship, prewrittenCII : auxData, valueCII: number){

        let letter = ""

        const d1 = ship.shipType.carbon_coefs_objects[0].d1
        const d2 = ship.shipType.carbon_coefs_objects[0].d2
        const d3 = ship.shipType.carbon_coefs_objects[0].d3
        const d4 = ship.shipType.carbon_coefs_objects[0].d4

        const lim_superior = d1 * prewrittenCII.value
        const lim_mas_bajo = d2 * prewrittenCII.value
        const lim_mas_alto = d3 * prewrittenCII.value
        const lim_inferior = d4 * prewrittenCII.value
        
        //clasificamos el barco
        if(valueCII< lim_superior){
            letter = "A"
        }else if(valueCII >= lim_superior && valueCII < lim_mas_bajo){
            letter = "B"
        }else if(valueCII>= lim_mas_bajo && valueCII < lim_mas_alto){
            letter = "C"
        }else if(valueCII >= lim_mas_alto && valueCII < lim_inferior){
            letter = "D"
        }else if(valueCII >= lim_inferior){
            letter = "E"
        }

        return letter
    }

    public calc_reference_CII(ship: Ship){

        //a y c lo saco de ShipTypes, la capacidad con datos que sacamos de estos inputs porque son del buque

        let a = 0
        let c = 0

        if(ship.shipType.code === shipTypeCodes.GasCarrier){
            if(ship.dwt >= 65000){
                a = ship.shipType.carbon_coefs_objects[1].a
                c = ship.shipType.carbon_coefs_objects[1].c
            }else{
                a = ship.shipType.carbon_coefs_objects[0].a
                c = ship.shipType.carbon_coefs_objects[0].c
            }
        }else if(ship.shipType.code === shipTypeCodes.GeneralCargoVessels){

            if(ship.dwt >= 20000){
                a = ship.shipType.carbon_coefs_objects[1].a
                c = ship.shipType.carbon_coefs_objects[1].c
            }else{
                a = ship.shipType.carbon_coefs_objects[0].a
                c = ship.shipType.carbon_coefs_objects[0].c
            }

        }else if(ship.shipType.code === shipTypeCodes.LNG){

            if(ship.dwt >= 100000){
                a = ship.shipType.carbon_coefs_objects[1].a
                c = ship.shipType.carbon_coefs_objects[1].c
            }else{
                a = ship.shipType.carbon_coefs_objects[0].a
                c = ship.shipType.carbon_coefs_objects[0].c
            }
 
        }else if(ship.shipType.code === shipTypeCodes.ROROCargo){

            if(ship.dwt < 30000){
                a = ship.shipType.carbon_coefs_objects[0].a
                c = ship.shipType.carbon_coefs_objects[0].c
            }else{
                a = ship.shipType.carbon_coefs_objects[2].a
                c = ship.shipType.carbon_coefs_objects[2].c
            }

        }else{
            a = ship.shipType.carbon_coefs_objects[0].a
            c = ship.shipType.carbon_coefs_objects[0].c
        }

        //console.log("a: " + a)
        //console.log("c: " + c)

        const capacity = this.calc_capacity(ship.dwt, ship.gt, ship.shipType)
        //console.log("capacity: " + capacity)
        const ciiref = a * Math.pow(capacity, (-1 * c))

        return ciiref
    }

    private calc_capacity(dwt: number, gt: number, shipType: ShipType) {
        let result = dwt

        if (shipType.code === shipTypeCodes.BulkCarrier && dwt >= 279000) {
            result = 279000
        } else if (shipType.code === shipTypeCodes.LNG && dwt < 65000) {
            result = 65000
        } else if (
            shipType.code === shipTypeCodes.RORO ||
            shipType.code === shipTypeCodes.ROROCargo ||
            shipType.code === shipTypeCodes.ROPAX ||
            shipType.code === shipTypeCodes.Passengers ||
            shipType.code === shipTypeCodes.HighCraftROPAX
        ) {

            if(shipType.code === shipTypeCodes.ROROCargo && gt >= 57700){
                result = 57700
            }
            result = gt
        }

        return result
    }

    private calc_fi(ship: Ship, data: NeobuqCarbonData){

        let fi = 1

        //es de clase hielo
        if(ship.iceClassType.code != "NONE"){

            let fi_ice = 1
            let fi_cb = 1

            //calculamos fi_ice
            if(ship.iceClassType.code == "IC"){
                fi_ice = 1.0041 + (58.5/ship.dwt)

            }else if(ship.iceClassType.code == "IB"){
                fi_ice = 1.0067 + (62.7/ship.dwt)

            }else if(ship.iceClassType.code == "IA"){
                fi_ice = 1.0099 + (95.1/ship.dwt)

            }else if(ship.iceClassType.code == "IA Super"){
                fi_ice = 1.0151 + (228.7/ship.dwt)
            }

            if(ship.shipType.code == "GCV" || ship.shipType.code == "TNK" || ship.shipType.code == "BLC"){
                //calculamos fi_cb
                let cb = 0
                let cb_ref = 0
                if(ship.shipType.code == "GCV"){
                    cb_ref = 0.80
                }else if(ship.shipType.code == "TNK"){

                    if(ship.dwt < 25000){
                        cb_ref = 0.78
                    }else if(ship.dwt >= 25000 && ship.dwt < 55000){
                        cb_ref = 0.80
                    }else if(ship.dwt >= 55000){
                        cb_ref = 0.83
                    }

                }else if(ship.shipType.code == "BLC"){

                    if(ship.dwt < 10000){
                        cb_ref = 0.78
                    }else if(ship.dwt >= 10000 && ship.dwt < 25000){
                        cb_ref = 0.80
                    }else if(ship.dwt >= 25000 && ship.dwt < 55000){
                        cb_ref= 0.82
                    }else if(ship.dwt >= 55000){
                        cb_ref = 0.86
                    }
                }

                //calculamos fi_cb
                cb = ship.displacementVolume / (ship.lpp * ship.ds * ship.bs) 
                fi_cb = cb_ref * cb

                if(fi_cb < 1){
                    fi_cb = 1
                }

            }else{
                fi_cb = 1
            }

            fi = fi_ice * fi_cb
    
        }else{
            fi = 1
        }

        return fi
    }

    private calc_fm(ship: Ship, data: NeobuqCarbonData){

        let fm = 1;

        if(ship.iceClassType.code == "IA Super" || ship.iceClassType.code == "IA"){
            fm = 1.05
        }

        return fm
    }

    private calc_fc(ship: Ship, data: NeobuqCarbonData){

        let fc = 1

        if(ship.shipType.code == "TNK" && data.shipChemicalTanker){
            
            const r = ship.dwt / ship.vTanks

            if(r < 0.98){
                fc =  Math.pow(r, -0.7) - 0.014
            }else{
                fc = 1
            }

        }else if(ship.shipType.code == "LNG"){

            fc = Math.pow(ship.dwt / ship.vTanks, -0.56)

        }else if(ship.shipType.code == "RPV"){

            const aux = ship.dwt / ship.gt

            if(aux < 0.25){
                fc = Math.pow((aux/0.25), -0.8)
            }else{
                fc = 1
            }

        }else if(ship.shipType.code == "RRS"){

            const aux = ship.dwt / ship.gt

            if(aux < 0.35){
                fc = Math.pow((aux/0.35), -0.8)
            }else{
                fc = 1
            }

        }else if(ship.shipType.code == "BLC" && data.shipLightTransport){

            const r = ship.dwt / ship.vTanks

            if(r < 0.55){
                fc = Math.pow(r, -0.15)
            }else{
                fc = 1
            }

        }else{
            fc = 1
        }

        return fc
    }

    private calc_fi_vse(ship: Ship, data: NeobuqCarbonData){

        //si en los inputs hemos marcado si tiene mejoras estructurales voluntarias
        let fi_vse = 1
        if(data.shipStructuralImprovements){
            const displacement = ship.displacementVolume
            const lwt_reference_design = ship.lwtReferenceDesign
            const lwt_enhanced_design = ship.lwtEnhancedDesign
            const dwt_reference_design = displacement - lwt_reference_design
            const dwt_enhanced_design = displacement - lwt_enhanced_design
            fi_vse = dwt_reference_design / dwt_enhanced_design
        }

        return fi_vse
    }
 
}

export default NeobuqCarbonService;